<template>
    <div class="block-boy">
        <p class="block-boy__text block-boy__text-one">
            Адаптация занимает от нескольких недель до нескольких месяцев. Ребенок может капризничать, часто болеть и
            плакать по утрам. Когда детский сад находится рядом с домом, процесс привыкания проходит легче. В хорошем
            детском саду <a href="https://pikabu.ru/story/dofeniot_shcv_eodidofaesv_onloolnaeshkikiknkh_2701192" class="app__link app__link--red" target="_blank">должно быть много места для игры и разных занятий</a>. Может быть, даже собственное маленькое футбольное поле.
        </p>
        <BlockParallax
            fixed
            speed="14"
            direction="top"
            transform="translateY"
            class="block-boy__img block-boy__img block-boy__img-one"
        >
            <img
                srcset="../assets/8.1-img.jpg, ../assets/8.1-img@2x.jpg 2x"
                src="../assets/8.1-img.jpg"
            >
            <div class="image-caption image-caption--overlap">Детский сад в&nbsp;проекте<br class="no-mobile"> «Варшавское шоссе 141»</div>
        </BlockParallax>
        <p class="block-boy__text block-boy__text-two">
            Одновременно с садом многие дети начинают ходить на дополнительные занятия: рисование, гимнастика, пение.
            Кружки можно найти рядом с домом или прямо в детском саду. Так ребенок не будет уставать от дороги и пробок,
            а родителям не придется менять свой график или искать няню.
        </p>

        <BlockParallax
            class="block-boy__img block-boy__img-two"
            fixed
            speed="10"
            offset="350"
            direction="top"
            transform="translateY"
        >
            <img
                srcset="../assets/9-img.jpg, ../assets/9-img@2x.jpg 2x"
                src="../assets/9-img.jpg"
            >
            <div class="image-caption">Детский сад в проекте «Бунинские луга»</div>
        </BlockParallax>
        <BlockParallax class="block-boy__icon block-boy__icon-lego-green-one" speed="10" direction="left" transform="rotate">
            <img
                srcset="@/assets/images/icons/lego-green.png, @/assets/images/icons/lego-green@2x.png 2x"
                src="@/assets/images/icons/lego-green.png"
            >
        </BlockParallax>
        <BlockParallax class="block-boy__icon block-boy--icon-desktop block-boy__icon-lego-green-two" speed="10" direction="right" transform="rotate">
            <img
                srcset="@/assets/images/icons/lego-green.png, @/assets/images/icons/lego-green@2x.png 2x"
                src="@/assets/images/icons/lego-green.png"
            >
        </BlockParallax>
        <BlockParallax class="block-boy__icon block-boy--icon-desktop block-boy__icon-cube" speed="10" direction="left" transform="rotate">
            <img
                srcset="@/assets/images/icons/cube.png, @/assets/images/icons/cube@2x.png 2x"
                src="@/assets/images/icons/cube.png"
            >
        </BlockParallax>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-boy {
        position relative
        margin-top 2.6rem
        display flex
        flex-direction column
        align-items flex-end

        &__text {
            font-size 1.5rem
            line-height 1.47
            color $color-text
            padding-left 5rem
            padding-right 1.8rem
            margin 0
            +layout-sm-and-up() {
                max-width 38rem
                padding 0
            }
            +layout-md-and-up() {
                max-width 36rem
                margin-right 9rem
            }
        }

        &__text-two {
            margin-top 2.1rem
        }

        &__img-one {
            margin 2.5rem -1rem 0 3.1rem
            max-width 38rem
            +layout-xs-and-up() {
                margin-left auto
                margin-right auto
            }
            +layout-sm-and-up() {
                position absolute
                left 0
                top 6rem
                margin-top 0
                z-index 1
            }
            +layout-md-and-up() {
                top 21rem
            }
        }

        &__img-two {
            margin 3rem -1rem 0 -1rem
            +layout-xs-and-up() {
                margin-left 0
                margin-right 0
            }
            +layout-sm-and-up() {
                position relative
                z-index 2
            }
            +layout-md-and-up() {
                margin-top 9rem
            }
        }

        &__icon {
            position absolute
        }

        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__icon-lego-green-one {
            width 7rem
            top 2.4rem
            left -3.9rem
            transform rotate(14deg)
            +layout-md-and-up() {
                top auto
                bottom -7rem
                left 2.8rem
                width 15.2rem
            }
        }

        &__icon-lego-green-two {
            +layout-md-and-up() {
                bottom 8.3rem
                right -24.1rem
                width 15rem
                height 8rem
            }
        }

        &__icon-cube {
            +layout-md-and-up() {
                bottom 6.9rem
                left -19.7rem
                width 15rem
                height 8rem
            }
        }
    }
</style>
